import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";

import styles from "./HeaderLink.css";

export default function HeaderLink(props) {
  return (
    <NavLink
      exact
      to={props.to}
      className={styles.root}
      activeClassName={styles.active}
    >
      {props.children}
    </NavLink>
  );
}

HeaderLink.propTypes = {
  to: PropTypes.string.isRequired,
};
